/* Accessibility Updates. */
document.querySelectorAll('a[href$=".pdf"]').forEach(link => link.innerHTML += '<span class="sr-only">(opens PDF)</span>');
document.querySelectorAll('a[href^="mailto:"]').forEach(link => link.innerHTML += '<span class="sr-only">(opens default email app)</span>');
document.querySelectorAll('a[href^="tel:"]').forEach(link => link.innerHTML += '<span class="sr-only">(opens telephone link)</span>');
document.querySelectorAll('a[target="_blank"]').forEach(link => link.innerHTML += '<span class="sr-only">(opens in a new tab)</span>');



document.addEventListener('DOMContentLoaded', function() {
    // Find skip link and main content
    const skipLink = document.querySelector('.skip-link');
    const mainContent = document.querySelector('main');
    
    if (!skipLink || !mainContent) return;

    // Ensure main content has tabindex if not already set
    if (!mainContent.hasAttribute('tabindex')) {
        mainContent.setAttribute('tabindex', '-1');
    }

    // Handle click/keyboard activation of skip link
    skipLink.addEventListener('click', function(e) {
        e.preventDefault();
        mainContent.focus();
    });

    // Clean up tabindex when focus leaves main content
    mainContent.addEventListener('blur', function() {
        // Only remove if it was automatically added
        if (mainContent.getAttribute('tabindex') === '-1') {
            mainContent.removeAttribute('tabindex');
        }
    });
});